import React, {useState} from "react";
import {useNavigate} from "react-router";
import {useAccessInfo} from "../../../hooks";
import {Role} from "../../../models/Role";
import {
    MY_PATIENTS_CLEAR_ROUTE,
    MY_PATIENTS_ROUTE, MY_RECORDS_CLEAR_ROUTE,
    MY_RECORDS_ROUTE, PATIENTS_CLEAR_ROUTE,
    PATIENTS_ROUTE, RECORDS_CLEAR_ROUTE,
    RECORDS_ROUTE, USERS_CLEAR_ROUTE,
    USERS_ROUTE
} from "../../../routes";
import {RECENT_LIST_PAGE_SIZE} from "../../../settings";
import {RecentPatients} from "../../Widgets/RecentPatients/RecentPatients";
import {RecentRecords} from "../../Widgets/RecentRecords/RecentRecords";
import {RecentUsers} from "../../Widgets/RecentUsers/RecentUsers";
import './Dashboard.css';
import {StudyType} from "../../Widgets/StudyIcon/StudyIcon";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function Dashboard() {
    const history = useNavigate();
    const isSupport = useAccessInfo(Role.Support);
    const recordsMenu = useListContextMenu();
    const studiesMenu = useListContextMenu();
    const patientsMenu = useListContextMenu();
    const usersMenu = useListContextMenu();
    const [studyType, setStudyType] = useState<StudyType | null>(null);
    const recordsBase = isSupport ? RECORDS_ROUTE : MY_RECORDS_ROUTE;
    const patientsBase = isSupport ? PATIENTS_ROUTE : MY_PATIENTS_ROUTE;
    const recordPath = (id: string) => `${recordsBase}/${id}`;
    const patientPath = (id: string) => `${patientsBase}/${id}`;
    const userPath = (id: string) => `${USERS_ROUTE}/${id}`;
    const studyPath = (id: string, type: StudyType) => {
        switch (type) {
            case StudyType.Ecg:
                return `${recordPath(id)}/ecg`;
            case StudyType.Stethoscope:
                return `${recordPath(id)}/stethoscope`;
            case StudyType.Spiro:
                return `${recordPath(id)}/spiro`;
            default:
                return recordPath(id);
        }
    };
    const allPatientsClickHandler = () => {
        history(isSupport ? PATIENTS_CLEAR_ROUTE : MY_PATIENTS_CLEAR_ROUTE);
    };
    const allRecordsClickHandler = () => {
        history(isSupport ? RECORDS_CLEAR_ROUTE : MY_RECORDS_CLEAR_ROUTE);
    };
    const allUsersClickHandler = () => {
        history(USERS_CLEAR_ROUTE);
    };
    const patientClickHandler = (id: string) => {
        history(patientPath(id));
    };
    const recordClickHandler = (id: string) => {
        history(recordPath(id));
    };
    const studyClickHandler = (id: string, type: StudyType) => {
        history(studyPath(id, type));
    };
    const userClickHandler = (id: string) => {
        history(userPath(id));
    };
    const recordContextMenuHandler = (id: string, x: number, y: number) => {
        studiesMenu.close();
        recordsMenu.onContextMenu(id, x, y);
    };
    const studyContextMenuHandler = (id: string, type: StudyType, x: number, y: number) => {
        recordsMenu.close();
        setStudyType(type);
        studiesMenu.onContextMenu(id, x, y);
    };
    const openRecord = () => {
        if (recordsMenu.targetId) {
            recordClickHandler(recordsMenu.targetId);
        }
    };
    const openRecordInNewTab = () => {
        if (recordsMenu.targetId) {
            openInNewTab(recordPath(recordsMenu.targetId));
        }
    };
    const openStudy = () => {
        if (studiesMenu.targetId !== null && studyType !== null) {
            studyClickHandler(studiesMenu.targetId, studyType);
        }
    };
    const openStudyInNewTab = () => {
        if (studiesMenu.targetId !== null && studyType !== null) {
            openInNewTab(studyPath(studiesMenu.targetId, studyType));
        }
    };
    const openPatient = () => {
        if (patientsMenu.targetId) {
            patientClickHandler(patientsMenu.targetId);
        }
    };
    const openPatientInNewTab = () => {
        if (patientsMenu.targetId) {
            openInNewTab(patientPath(patientsMenu.targetId));
        }
    };
    const openUser = () => {
        if (usersMenu.targetId) {
            userClickHandler(usersMenu.targetId);
        }
    };
    const openUserInNewTab = () => {
        if (usersMenu.targetId) {
            openInNewTab(userPath(usersMenu.targetId));
        }
    };
    return (
        <div className="dashboard-container">
            <div className="dashboard-item">
                <RecentRecords limit={RECENT_LIST_PAGE_SIZE} recordClickHandler={recordClickHandler}
                               allRecordsClickHandler={allRecordsClickHandler} studyClickHandler={studyClickHandler}
                               contextMenuHandler={recordContextMenuHandler} studyContextMenuHandler={studyContextMenuHandler}/>
            </div>
            <div className="dashboard-item">
                <RecentPatients limit={RECENT_LIST_PAGE_SIZE} patientClickHandler={patientClickHandler}
                                allPatientsClickHandler={allPatientsClickHandler} contextMenuHandler={patientsMenu.onContextMenu}/>
            </div>
            {isSupport &&
            <div className="dashboard-item">
                <RecentUsers limit={RECENT_LIST_PAGE_SIZE} userClickHandler={userClickHandler}
                             allUsersClickHandler={allUsersClickHandler} contextMenuHandler={usersMenu.onContextMenu}/>
            </div>
            }
            <ListItemContextMenu menuProps={recordsMenu.menuProps} anchorPoint={recordsMenu.anchorPoint}
                                 onClose={recordsMenu.close} onOpen={openRecord} onOpenInNewTab={openRecordInNewTab}/>
            <ListItemContextMenu menuProps={studiesMenu.menuProps} anchorPoint={studiesMenu.anchorPoint}
                                 onClose={studiesMenu.close} onOpen={openStudy} onOpenInNewTab={openStudyInNewTab}/>
            <ListItemContextMenu menuProps={patientsMenu.menuProps} anchorPoint={patientsMenu.anchorPoint}
                                 onClose={patientsMenu.close} onOpen={openPatient} onOpenInNewTab={openPatientInNewTab}/>
            <ListItemContextMenu menuProps={usersMenu.menuProps} anchorPoint={usersMenu.anchorPoint}
                                 onClose={usersMenu.close} onOpen={openUser} onOpenInNewTab={openUserInNewTab}/>
        </div>
    );
}

export default Dashboard;
